<template>
  <BaseInput :label="label"
             v-model="formatted_val"
             :textAlign="textAlign"
             :read-only-style="readOnlyStyle"
             :disabled="disabled"
             @keydown="keydown"
             @focusin="focusIn"
             @focusout="focusOut">
    <template v-slot:errors="">
      <slot name="errors"></slot>
    </template>
  </BaseInput>
</template>

<script>
import {mapGetters} from "vuex";
import BaseInput from "@/components/UI/BaseInput/BaseInput";

export default {
  name: "ValueInput",
  inheritAttrs: false,
  components: {BaseInput},
  props: {
    currency_id: {
      //should be accounts or space currency_id
      required: true
    },
    label: {
      type: String,
      default: null
    },
    value: {
      required: true
    },
    allow_negative: {
      type: Boolean,
      default: false
    },
    textAlign: {
      type: String,
      default: 'right'
    },
    readOnlyStyle: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      focus: false,
    }
  },
  computed: {
    ...mapGetters('cabinet/currencies', ['formattedCurrencyValue', 'getCurrencyById']),
    currency() {
      return !!this.currency_id
          ? this.getCurrencyById(this.currency_id)
          : {decimals: 2, symbol: ''};
    },
    formatted_val: {
      get() {
        if (!this.focus && this.value !== null && !!this.value) {
          return `${this.getFormattedValue(this.value)} ${this.currency.symbol}`
        } else {
          return this.value;
        }
      },
      set(value) {
        let val = value;
        //handle comma and replace on dot
        if (val.indexOf(',') > -1) {
          val = val.replace(',', '.')
        }
        val = val.replace(/[^\d.-]/g, '') //handle only digits
        // check decimals length
        if (val.indexOf('.') > -1) {
          let parts = val.split('.')
          if (parts[1].length > this.currency.decimals) {
            parts[1] = parts[1].substring(0, this.currency.decimals)
          }
          val = parts.join(".");
        }
        let outside = val;
        if (val === '.' || val === ',' || val === '-') {
          // this.$emit('input', null)
        } else if (val === '') {
          this.$emit('input', null)
        } else {
          this.$emit('input', outside)
        }
      }
    }
  },
  methods: {
    getFormattedValue(x) {
      if (x.toString().indexOf('.') > -1) { //if number got decimals
        let parts = x.toString().split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        if (parts[1].length > this.currency.decimals) { //check decimals length
          parts[1] = parts[1].substring(0, this.currency.decimals)
        }
        return parts.join(".");
      } else { //just simple formatting w spaces
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
      }
    },
    focusIn(e) {
      this.focus = true;
      this.$emit('focusin', e);
    },
    focusOut(e) {
      this.focus = false;
      this.$emit('focusout', e);
    },
    keydown(e) {
      if (e.key === 'Enter') {
        this.$emit('keydownEnter');
      }
      //disable non numeric keys on input to imitate number input
      if (this.allow_negative) {
        if (e.key.length === 1 && e.key !== '.' && e.key !== '-' && e.key !== ',' && isNaN(e.key) && !e.ctrlKey && !e.metaKey ||
            ((e.key === ',' || e.key === '.') && (e.target.value.indexOf('.') > -1 || e.target.value.indexOf(',') > -1))
            || (e.key === '-' && (e.target.value.indexOf('-') > -1))
        ) {
          e.preventDefault();
        }
      } else {
        if (e.key.length === 1 && e.key !== '.' && e.key !== ',' && isNaN(e.key) && !e.ctrlKey && !e.metaKey ||
            ((e.key === ',' || e.key === '.') && (e.target.value.indexOf('.') > -1 || e.target.value.indexOf(',') > -1))
        ) {
          e.preventDefault();
        }
      }
    }
  }
}
</script>
